"use client"

import {
  useAllAvatarSupporters,
  useAllSupporters,
} from "@/hooks/coins/useSupporters"
import { SupportersResp } from "@/types/coins"
import SupportersDialogDrawer from "./SupportersDialogDrawer"
import { getAvatars } from "@/lib/utils/supporters"

type Props = {
  initialData: {
    all: SupportersResp | undefined
    allAvatar: SupportersResp | undefined
  }
  coinId: string
  isOnlyAvatars?: boolean
}

export function AllSupportersDialog({
  initialData,
  coinId,
  isOnlyAvatars,
}: Props) {
  const { allSupporters } = useAllSupporters({
    initialData: initialData.all,
    coinId,
  })
  const { allAvatarSupporters } = useAllAvatarSupporters({
    initialData: initialData.allAvatar,
    coinId,
  })
  const avatars = getAvatars(allAvatarSupporters, allSupporters)

  if (!allSupporters || !avatars) return null

  return (
    <SupportersDialogDrawer
      avatars={avatars}
      supporters={allSupporters}
      isOnlyAvatars={isOnlyAvatars}
    />
  )
}
